enum StyleVariation {
  Primary = 'primary',
  Secondary = 'secondary',
  Default = 'default',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info'
}

export default StyleVariation
